module.exports = __webpack_public_path__ + "img/title-en-l.7476b5e0.svg";